'use client'

import * as SliderPrimitive from '@radix-ui/react-slider'
import * as React from 'react'

import { cn } from '@/utils/shadcn/utils'

const Slider = React.forwardRef<
  React.ElementRef<typeof SliderPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof SliderPrimitive.Root>
>(({ className, disabled, ...props }, ref) => (
  <SliderPrimitive.Root
    ref={ref}
    disabled={disabled}
    className={cn(
      'relative',
      'flex',
      'w-full',
      'items-center',
      'touch-none',
      'select-none',
      !disabled ? 'cursor-pointer' : 'cursor-not-allowed',
      className,
    )}
    {...props}
  >
    <SliderPrimitive.Track
      className={cn(
        'relative',
        'h-1',
        'w-full',
        'grow',
        'overflow-hidden',
        'rounded-full',
        'bg-moment-blue-grey-200',
        'dark:bg-moment-blue-grey-1000',
        'disabled:cursor-not-allowed',
      )}
    >
      <SliderPrimitive.Range
        className={cn(
          'absolute',
          'h-full',
          'bg-moment-teal-900',
          'dark:bg-moment-teal-800',
        )}
      />
    </SliderPrimitive.Track>
    {props.defaultValue?.map((_, index) => (
      <SliderPrimitive.Thumb
        key={index}
        className={cn(
          'block',
          'h-3.75',
          'w-1',
          'rounded-full',
          'bg-moment-teal-900',
          'dark:bg-moment-teal-800',
          'shadow-2xs',
          'transition-colors',
          'focus-visible:outline-hidden',
          'focus-visible:ring-1',
          'focus-visible:ring-ring',
          'focus-visible:ring-moment-teal-600',
          'disabled:pointer-events-none',
          'disabled:opacity-50',
          'cursor-grab active:cursor-grabbing',
          // Invisible padding for larger hit area using pseudo-element
          'before:content-[""]',
          'before:absolute',
          'before:inset-0',
          'before:scale-x-[3] before:scale-y-[2] ',
          'before:rounded-full',
        )}
      />
    ))}
  </SliderPrimitive.Root>
))
Slider.displayName = SliderPrimitive.Root.displayName

export { Slider }
